import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconSearchAnnotation({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="7" y="9" width="10" height="1" rx=".5" fill={fill}/>
            <rect x="8" y="12" width="9" height="1" rx=".5" fill={fill}/>
            <path fill={fill} fill-rule="evenodd" clip-rule="evenodd" d="M5 6h14v10H7.83c.11.313.17.65.17 1h11a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v8.17c.313-.11.65-.17 1-.17V6z"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" fill={fill}/>
        </svg>
    );
}

export default IconSearchAnnotation;
